import WSService from "./web-socket.service";
import { ErrorType } from "./api-error";
import { getMetricTemplateAnnotationsSuccessful, setCalculationHeatmapResults, setCalculationLineGraphResults, setCalculationMetadataResults, setCalculationTabularResults, setSocketError, setSocketStatus, setWorkspaceServerError, setWorkspaceServerWarning, socketReconnected, socketReconnecting, socketSubscribeMessage, updateWorkspace, workspaceSocketStatus, } from "store/ps-workspace/ps-workspace.actions";
import { EngineResultType, SocketStatus, } from "store/ps-workspace/ps-workspace.types";
import logger from "utils/logger";
import { setOffline } from "store/global/global.actions";
import { UPDATE_WORKSPACE_SOCKET_METHODS } from "store/ps-workspace/ps-workspace.update.types";
export var IncomingPsSocketMessage;
(function (IncomingPsSocketMessage) {
    IncomingPsSocketMessage["SUBSCRIBED"] = "Subscribed";
    IncomingPsSocketMessage["WORKSPACE_STATE"] = "WorkspaceState";
    IncomingPsSocketMessage["ERROR"] = "Error";
    IncomingPsSocketMessage["RESULT_STATE"] = "ResultState";
    IncomingPsSocketMessage["TEMPLATE_ANNOTATION"] = "TemplateAnnotation";
    IncomingPsSocketMessage["TIMEOUT"] = "Timeout";
    IncomingPsSocketMessage["ENGINE_INTERNAL_ERROR"] = "EngineInternalError";
    IncomingPsSocketMessage["EXPIRED_LICENSES"] = "ExpiredLicenses";
})(IncomingPsSocketMessage || (IncomingPsSocketMessage = {}));
const getCallbacks = (emitter) => ({
    methods: {
        [IncomingPsSocketMessage.SUBSCRIBED]: (requestId, seats) => emitter(socketSubscribeMessage({ requestId, seats })),
        [IncomingPsSocketMessage.WORKSPACE_STATE]: (requestId, workspace, message) => {
            if (message) {
                emitter(setWorkspaceServerWarning(message));
            }
            emitter(workspaceSocketStatus({ requestId, workspace }));
        },
        [IncomingPsSocketMessage.RESULT_STATE]: (_workspaceId, result) => {
            switch (result.type) {
                case EngineResultType.Result0D:
                    return emitter(setCalculationTabularResults(result));
                case EngineResultType.Result1D:
                    return emitter(setCalculationLineGraphResults(result));
                case EngineResultType.Result2D:
                    return emitter(setCalculationHeatmapResults(result));
                case EngineResultType.ResultMetadata:
                    return emitter(setCalculationMetadataResults(result));
            }
        },
        [IncomingPsSocketMessage.TEMPLATE_ANNOTATION]: (_requestId, result) => {
            emitter(setSocketStatus(SocketStatus.ACTUAL));
            emitter(getMetricTemplateAnnotationsSuccessful(result));
        },
        [IncomingPsSocketMessage.TIMEOUT]: () => {
            emitter(setSocketError({
                requestId: 0,
                errors: [
                    {
                        propertyName: "session",
                        text: "Your session expired due to inactivity, refresh the page to continue.",
                        errorType: ErrorType.Forbidden,
                        title: "Session Expired",
                    },
                ],
            }));
            WSService.instance.stop();
        },
        [IncomingPsSocketMessage.EXPIRED_LICENSES]: (error) => {
            emitter(setSocketStatus(SocketStatus.ERROR));
            emitter(setSocketError({
                requestId: 0,
                errors: [error],
            }));
            WSService.instance.stop();
        },
        [IncomingPsSocketMessage.ENGINE_INTERNAL_ERROR]: (_workspaceId, error) => {
            emitter(setSocketStatus(SocketStatus.ERROR));
            if (error.errors[0]?.values) {
                const { values, title, errorType } = { ...error.errors[0] };
                const { ResultSetId, ResultSetElementId, ResultSetElementTypeValue } = { ...values };
                emitter(updateWorkspace({
                    method: UPDATE_WORKSPACE_SOCKET_METHODS.RemoveResultSetElement,
                    data: {
                        resultSetId: ResultSetId,
                        resultSetElementId: ResultSetElementId,
                        resultSetElementType: ResultSetElementTypeValue,
                    },
                }));
                setTimeout(() => emitter(setSocketError({
                    requestId: 0,
                    errors: [
                        {
                            propertyName: "engineInternal",
                            text: title,
                            errorType: ErrorType[errorType],
                            title: "Error during calculation",
                            reportMail: "ProcessInsights@Sartorius.com",
                        },
                    ],
                })), 400);
            }
            else {
                emitter(setSocketError({
                    requestId: 0,
                    errors: [
                        {
                            propertyName: "engineInternal",
                            text: "The unexpected server error occurred. Contact system administrator.",
                            errorType: ErrorType.Unknown,
                            title: "Internal Server Error",
                        },
                    ],
                }));
            }
            logger.error(error);
        },
        [IncomingPsSocketMessage.ERROR]: (requestId, data) => {
            if (data.errors.some((i) => i.errorType === ErrorType.Internal)) {
                emitter(setWorkspaceServerError({ status: 500, data }));
            }
            else {
                emitter(setSocketError({ requestId, errors: data.errors }));
            }
        },
    },
    reconnecting: () => emitter(socketReconnecting()),
    reconnected: () => emitter(socketReconnected()),
    close: () => emitter(setOffline(true)),
});
export { getCallbacks };
